"use client";

import confetti from "canvas-confetti";
import { useEffect, useRef } from "react";

export function ConfettiCanvas() {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    if (!canvasRef.current) return;

    const myConfetti = confetti.create(canvasRef.current, {
      resize: true,
      useWorker: true,
    });

    // Initial burst of confetti
    myConfetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 },
      colors: ["#FCD34D", "#FBBF24", "#F59E0B", "#D97706", "#FEF3C7"],
    });

    // Followed by a series of smaller bursts
    setTimeout(() => {
      myConfetti({
        particleCount: 50,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: ["#FCD34D", "#FBBF24", "#F59E0B", "#D97706", "#FEF3C7"],
      });
    }, 750);

    setTimeout(() => {
      myConfetti({
        particleCount: 50,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: ["#FCD34D", "#FBBF24", "#F59E0B", "#D97706", "#FEF3C7"],
      });
    }, 1500);

    // Clean up
    return () => {
      myConfetti.reset();
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="pointer-events-none fixed inset-0 z-50 w-full h-full"
    />
  );
}
